<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getCarTypeList,
  getDepartmentAllList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        waringTypeOptions: [],
        vehicleStatusTypeOptions: [],
        orgIdOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '司机',
            value: 'userName',
            type: 'input',
            placeholder: '司机',
          },
          {
            label: '牌照类型',
            value: 'licenceType',
            type: 'select',
            placeholder: '请选择牌照类型',
            default: '-1',
            options: [{
              label: '全部',
              value: '-1',
            }, {
              label: '整车',
              value: '1',
            }, {
              label: '牵引车',
              value: '2',
            }, {
              label: '挂车',
              value: '3',
            }],
          },
          {
            label: '车辆类型',
            value: 'vehicleStatusType',
            type: 'cascader',
            normal: true,
            default: [],
          },
          {
            label: '预警类型',
            value: 'waringType',
            type: 'select',
            placeholder: '请选择预警类型',
            default: '-1',
          },
          {
            label: '预警时间',
            value: 'warnDate',
            type: 'date',
            placeholder: '请输入预警时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '处理状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择处理状态',
            defalut: '-1',
            options: [
              {
                label: '全部',
                value: '-1',
              }, {
                label: '未处理',
                value: '1',
              }, {
                label: '已处理',
                value: '2',
              },
            ],
          },
          {
            label: '处理时间',
            value: 'dealDate',
            type: 'date',
            placeholder: '请输入处理时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '处理人',
            value: 'dealUserName',
            type: 'input',
            placeholder: '请输入处理人',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
          },
          {
            label: '归属员工',
            value: 'relUserName',
            type: 'input',
            placeholder: '请输入归属员工',
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.warnDate && searchBoxData.warnDate.length) {
        searchBoxData.startDate = this.formatDate(searchBoxData.warnDate[0]);
        searchBoxData.endDate = this.formatDate(searchBoxData.warnDate[1]);
      }
      // 处理时间
      if (searchBoxData.dealDate && searchBoxData.dealDate.length) {
        searchBoxData.startDealDate = this.formatDate(searchBoxData.dealDate[0]);
        searchBoxData.endDealDate = this.formatDate(searchBoxData.dealDate[1]);
      }
      if (searchBoxData.vehicleStatusType && searchBoxData.vehicleStatusType.length) {
        searchBoxData.vehicleStatus = searchBoxData.vehicleStatusType[0];
        searchBoxData.vehicleLength = searchBoxData.vehicleStatusType[1];
      } else {
        searchBoxData.vehicleStatus = '-1';
        searchBoxData.vehicleLength = '-1';
      }
      if (searchBoxData.waringType === '-1') {
        // 之前的版本是在这里写死的
        searchBoxData.waringType = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].join();
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'WARING_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    const vehicleStatusEnumsList = await getCarTypeList();
    const orgIdOptions = await getDepartmentAllList({ isArchive: true});
    this.searchBoxData.waringTypeOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.vehicleStatusTypeOptions = vehicleStatusEnumsList;
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...orgIdOptions,
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
